export const educationData = [
  {
    id: 1,
    institution: 'CEG, Anna University',
    degree: 'B.Tech, Information Technology',
    period: '2021 – 2025',
    grade: 'GPA: 8.34',
    location: 'Chennai, India',
    details: 'Completed B.Tech degree in Information Technology with focus on software development, cloud computing, and machine learning.',
    logo: '/Portfolio/images/ceg-logo.png',
  },
  {
    id: 2,
    institution: 'Jaycee Higher Secondary School',
    degree: 'Higher Secondary',
    period: '2020 – 2021',
    grade: 'Percentage: 98.5%',
    location: 'Tamil Nadu, India',
    details: 'Completed higher secondary education with excellence in mathematics and computer science.',
    logo: '/Portfolio/images/jaycee-logo.png',
  },
];
